/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import { getBraindateId } from '@braindate/domain/lib/braindate/util';

import CheckInActionButtonDumb from './CheckInActionButtonDumb';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import { isBraindateCheckInReady } from 'src/shared/domain/braindate/util/braindateUtil';
import { isCheckInIsFetching } from 'src/shared/app/check-in/selector/uiCheckInSelector';
import { forceVideoOverlay } from 'plugin/virtual-braindate/slice/virtualBraindateSlice';

type Props = {
  braindate: Braindate,
  onClick?: () => void,
};

const mapStateToProps = (
  state: Object,
  { braindate, onClick, ...props }: Props,
): Object => ({
  ...props,
  braindate,
  onClick,
  selfUser: getSelf(state),
  isBraindateCheckInReady: isBraindateCheckInReady(braindate),
  isFetching: isCheckInIsFetching(state, { id: getBraindateId(braindate) }),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { onClick, ...restProps } = stateProps;

  return {
    ...restProps,
    handleLinkClick() {
      if (onClick) {
        onClick();
      }

      dispatch(forceVideoOverlay(true));
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInActionButtonDumb);
